__turbopack_context__.v({
  "actionDivider": "work-list-actions-module-scss-module__1hwB0G__actionDivider",
  "addedWishList": "work-list-actions-module-scss-module__1hwB0G__addedWishList",
  "bookmarkIcon": "work-list-actions-module-scss-module__1hwB0G__bookmarkIcon",
  "chevronIcon": "work-list-actions-module-scss-module__1hwB0G__chevronIcon",
  "createListButton": "work-list-actions-module-scss-module__1hwB0G__createListButton",
  "createListForm": "work-list-actions-module-scss-module__1hwB0G__createListForm",
  "createListInput": "work-list-actions-module-scss-module__1hwB0G__createListInput",
  "createListSaveButton": "work-list-actions-module-scss-module__1hwB0G__createListSaveButton",
  "divider": "work-list-actions-module-scss-module__1hwB0G__divider",
  "heartIcon": "work-list-actions-module-scss-module__1hwB0G__heartIcon",
  "listActionSnackbar": "work-list-actions-module-scss-module__1hwB0G__listActionSnackbar",
  "listDropdown": "work-list-actions-module-scss-module__1hwB0G__listDropdown",
  "listGroup": "work-list-actions-module-scss-module__1hwB0G__listGroup",
  "loading": "work-list-actions-module-scss-module__1hwB0G__loading",
  "menuContent": "work-list-actions-module-scss-module__1hwB0G__menuContent",
  "menuHeading": "work-list-actions-module-scss-module__1hwB0G__menuHeading",
  "menuOpen": "work-list-actions-module-scss-module__1hwB0G__menuOpen",
  "menuOption": "work-list-actions-module-scss-module__1hwB0G__menuOption",
  "root": "work-list-actions-module-scss-module__1hwB0G__root",
  "saveToListText": "work-list-actions-module-scss-module__1hwB0G__saveToListText",
  "saveToListTrigger": "work-list-actions-module-scss-module__1hwB0G__saveToListTrigger",
  "selectedCheckIcon": "work-list-actions-module-scss-module__1hwB0G__selectedCheckIcon",
  "singleLineMessage": "work-list-actions-module-scss-module__1hwB0G__singleLineMessage",
  "snackbarLink": "work-list-actions-module-scss-module__1hwB0G__snackbarLink",
  "statusGroup": "work-list-actions-module-scss-module__1hwB0G__statusGroup",
  "successSnackbar": "work-list-actions-module-scss-module__1hwB0G__successSnackbar",
  "u-animation-bounce": "work-list-actions-module-scss-module__1hwB0G__u-animation-bounce",
  "wishListButton": "work-list-actions-module-scss-module__1hwB0G__wishListButton",
});
